import { render, staticRenderFns } from "./MenuSimpli.vue?vue&type=template&id=b34877f0&"
import script from "./MenuSimpli.vue?vue&type=script&lang=js&"
export * from "./MenuSimpli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports